import React from 'react';
import '../styles/Loader.css';

const Loader = () => {
  return (
    <div className="loader-dots">
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export default Loader;
